module.exports = __webpack_public_path__ + "img/poster1.jpg.a6ee6277.webp";